module.exports = __webpack_public_path__ + "img/GS_Profile-Luyanda Sibeko.40f11c57.png";